import { render, staticRenderFns } from "./coverageInfo.vue?vue&type=template&id=4aaf3b76&scoped=true&"
import script from "./coverageInfo.vue?vue&type=script&lang=js&"
export * from "./coverageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf3b76",
  null
  
)

export default component.exports